import { Component, HostListener } from '@angular/core';
import { MapService } from './map.service';
import { Countie, Member, TooltipText } from './map.model';
import { GlobalConstants } from 'src/app/common/global';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.sass'],
  standalone: true,
  imports: [CommonModule]
})

export class MapComponent {
  counties: Countie[] = [];
  tooltipVisible = false;
  tooltipText: TooltipText = {
    name: '',
    members: '',
    percentage: ''
  }
  tooltipPosition = { x: 0, y: 0 };
  members: Member = {
    total: 0,
    fromCroatia: 0,
    fromAbroad: 0
  }
  loader = document.getElementById("loader-container");

  constructor(
    private mapService: MapService,
  ) {
    this.loader!.style.display = "flex";
  }
  
  ngOnInit(): void {
    this.mapService.getMembersByCounties().subscribe((data: any) => {
      this.counties = data.data;
      
      this.counties.forEach(countie => {
        this.members.total += countie.members;
        if(countie.countyCode !== 22) {
          this.members.fromCroatia += countie.members;
        } else if(countie.countyCode === 22) {
          this.members.fromAbroad += countie.members
        }
      });

      this.counties.forEach(countie => {
        countie.percentage = parseFloat(((countie.members * 100) / this.members.total).toFixed(2));
      });

      if(!window.location.href.includes("membership") || !GlobalConstants.isAuth) {
        this.loader!.style.display = "none";
      }
    });
  }

  showTooltip(event: MouseEvent): void {
    const target = event.target as HTMLElement;
  
    if (target) {
      const parentGroup = target.closest('g');
  
      if (parentGroup && parentGroup.id) {  
        const countie = this.counties.find(z => z && z.countyCode === Number(parentGroup.id));
  
        if (countie) {
          this.tooltipVisible = true;
          this.tooltipText = {
            name: countie.county,
            members: countie.members.toString(),
            percentage: countie.percentage.toString()
          };

          this.colorPathsAndPolygons(parentGroup, "#B39963");
        }
      }
    }
  }

  colorPathsAndPolygons(parentGroup: any, color: string): void {
    const paths = parentGroup.querySelectorAll('path');
    const polygon = parentGroup.querySelectorAll('polygon');

    paths.forEach((path: { style: { fill: string; }; }) => {
      path.style.fill = color;
    });

    polygon.forEach((path: { style: { fill: string; }; }) => {
      path.style.fill = color;
    });
  }

  moveTooltip(event: MouseEvent): void {
    const tooltipWidth = 150;
    const padding = 10;
    const windowWidth = window.innerWidth;
  
    let xPosition = event.clientX + padding;
    let yPosition = event.clientY + padding;
  
    const isNearRightEdge = xPosition + tooltipWidth > windowWidth;
    if (isNearRightEdge) {
      xPosition = event.clientX - tooltipWidth - padding;
      document.querySelector('.tooltip')?.classList.add('left');
    } else {
      document.querySelector('.tooltip')?.classList.remove('left');
    }
  
    this.tooltipPosition = { x: xPosition, y: yPosition };
  }

  hideTooltip(event: MouseEvent): void {
    const target = event.target as HTMLElement;
  
    if (target) {
      const parentGroup = target.closest('g');
  
      if (parentGroup && parentGroup.id) {
        this.colorPathsAndPolygons(parentGroup, "#012641");
      }
    }
  
    this.tooltipVisible = false;
  }

  closeMap() {
    this.mapService.toggleMap(false);
  }
}
